import React from "react";
import { useLocation } from "react-router-dom";
import "./App.scss";
import AppRoutes from "./AppRoutes";
import Navbar from "./shared/Navbar";
import Sidebar from "./shared/Sidebar";
import { RECAPTCHA_SITE_KEY, APP_VERSION } from "../Util/constant";
import { useSideBar } from "./context/SideBarContext";
import { useTheme } from "./context/ThemeContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { ProfileContextProvider } from "./context/ProfileContext";
import { ConfigContextProvider } from "./context/ConfigContext";
import { JsonBridgeContextProvider } from "./context/JsonBridgeContext";
import { OrderManagerProvider } from "./context/OrderManagerContext";
import { BrokerContextProvider } from "./context/BrokerContext";
import { CustomBridgeContextProvider } from './context/CustomBridgeContext';
import { ChartinkContextProvider } from "./context/ChartinkContext";
import { ToolSubscriptionContextProvider } from "./context/ToolSubscriptionContext";
const App = () => {
    console.log("APP VERSION", APP_VERSION);

    const location = useLocation(); // Replace withRouter with useLocation
    const { toggleTheme, isDarkTheme } = useTheme();

    const noLayoutRoutes = ["/login", "/registration", "/dematconnected", "/forgot-password"];
    const { isSideBarOpen } = useSideBar();

    return (
        <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY} scriptProps={{ async: true, defer: true, appendTo: 'head', nonce: undefined, }} >
            <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false} closeOnClick pauseOnHover draggable theme={isDarkTheme ? "dark" : 'light'} style={{ zIndex: 99999 }} />
            {noLayoutRoutes.includes(location.pathname) ? (
                <AppRoutes />
            ) : (
                <ConfigContextProvider>
                    <ProfileContextProvider>
                        <ToolSubscriptionContextProvider>
                            <BrokerContextProvider>
                                <OrderManagerProvider>
                                    <JsonBridgeContextProvider>
                                        <CustomBridgeContextProvider>
                                            <ChartinkContextProvider>
                                                <div className="container-scroller">
                                                    <Sidebar />
                                                    <div className="container-fluid page-body-wrapper">
                                                        <Navbar />
                                                        <div className="main-panel">
                                                            <div className={`content-wrapper ${isSideBarOpen ? "content-wrapper-margin" : "content-wrapper-margin2"} ${isDarkTheme && "content-bg"}`}  >
                                                                <AppRoutes />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div >
                                            </ChartinkContextProvider>
                                        </CustomBridgeContextProvider>
                                    </JsonBridgeContextProvider>
                                </OrderManagerProvider>
                            </BrokerContextProvider>
                        </ToolSubscriptionContextProvider>
                    </ProfileContextProvider>
                </ConfigContextProvider>
            )}

        </GoogleReCaptchaProvider>

    );
};

export default (App); // Removed withRouter
